<div class="layout">
  <ng-content></ng-content>
</div>